import LegalLayout, { H2, H3, P, UL, LI } from "@/pages/LegalLayout";
import { BUSINESS } from "@/lib/site";

export default function Terms() {
  return (
    <LegalLayout
      testid="terms-page"
      title="Terms & Conditions"
      updated="June 2026"
    >
      <P>
        These Terms &amp; Conditions ("Terms") govern your use of{" "}
        {BUSINESS.domain} (the "Site") operated by Rolling Stone Marketing
        ("Rolling Stone Marketing," "we," "us," or "our"). By accessing or using
        the Site, or by submitting the contact form, you agree to these Terms.
      </P>

      <H2 id="use-of-site">1. Use of the Site</H2>
      <P>
        You may use the Site for lawful purposes only. You agree not to use the
        Site in any way that violates applicable law, infringes the rights of
        others, or interferes with the operation or security of the Site.
      </P>

      <H2 id="submissions">2. Submissions and Accuracy</H2>
      <P>
        When you submit information through the contact form, you agree to
        provide accurate and current information and that you are the owner of,
        or are authorized to provide, the email address and mobile phone number
        you enter. You are responsible for the accuracy of the information you
        submit.
      </P>

      <H2 id="email">3. Email Communications</H2>
      <P>
        If you opt in to email, you agree to receive marketing emails from
        Rolling Stone Marketing and may unsubscribe at any time using the link
        in any email. Email consent and SMS consent are collected separately;
        opting in to one does not opt you in to the other, and neither is
        required to submit the contact form.
      </P>

      <H2 id="sms-terms">4. SMS / Text Messaging Terms of Service</H2>
      <H3>Program description</H3>
      <P>
        If you opt in, Rolling Stone Marketing sends recurring marketing and
        customer care text messages to the mobile number you provide, related
        to your inquiry and our services, including messages sent by an
        automatic telephone dialing system.
      </P>
      <H3>How to opt in</H3>
      <P>
        You opt in only by checking the optional SMS consent checkbox on the
        contact form on this website. We never collect SMS opt-in from
        purchased, rented, appended, or third-party lists. Consent is not a
        condition of any purchase.
      </P>
      <H3>Message frequency</H3>
      <P>Message frequency varies (approximately 2-6 messages per month).</P>
      <H3>Cost</H3>
      <P>Message and data rates may apply.</P>
      <H3>How to opt out</H3>
      <P>
        You can cancel the SMS service at any time by replying STOP, END,
        CANCEL, UNSUBSCRIBE, or QUIT to any message. After you send one of these
        messages, we will send you a single confirmation message and then stop
        sending SMS messages to you. You may re-subscribe at any time by opting
        in again through the website.
      </P>
      <H3>How to get help</H3>
      <P>
        Reply HELP at any time for assistance. You may also contact us at{" "}
        {BUSINESS.email} or {BUSINESS.phone}.
      </P>
      <H3>Carrier liability</H3>
      <P>Carriers are not liable for delayed or undelivered messages.</P>
      <H3>Privacy</H3>
      <P>
        Your mobile information and SMS opt-in data are handled as described in
        our Privacy Policy and are not shared with third parties or affiliates
        for marketing or promotional purposes.
      </P>

      <H2 id="services">5. Services and Client Engagements</H2>
      <P>
        Rolling Stone Marketing provides data and marketing services, including
        aged data, web scraping, data appending, marketing consulting, paid
        advertising, and automation services, under separate agreements with
        clients.
      </P>
      <P>
        Clients who receive data or messaging services are solely responsible
        for their own compliance with all applicable laws and requirements
        governing their outreach, including the Telephone Consumer Protection
        Act (TCPA), applicable state telemarketing and consent laws, Do-Not-Call
        obligations, the CAN-SPAM Act, and all carrier messaging requirements.
        Nothing supplied by Rolling Stone Marketing constitutes consent to
        contact any individual, and clients are responsible for obtaining any
        consent required before contacting any person.
      </P>

      <H2 id="ip">6. Intellectual Property</H2>
      <P>
        The Site and its content, including text, graphics, logos, and design,
        are owned by or licensed to Rolling Stone Marketing and are protected by
        applicable intellectual property laws. You may not copy, reproduce, or
        distribute Site content without our prior written permission.
      </P>

      <H2 id="warranties">7. Disclaimer of Warranties</H2>
      <P>
        The Site is provided on an "as is" and "as available" basis without
        warranties of any kind, whether express or implied, including
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement. We do not warrant that the Site will be uninterrupted,
        error-free, or secure.
      </P>

      <H2 id="liability">8. Limitation of Liability</H2>
      <P>
        To the fullest extent permitted by law, Rolling Stone Marketing will not
        be liable for any indirect, incidental, special, consequential, or
        punitive damages, or any loss of profits or revenues, arising out of or
        related to your use of the Site.
      </P>

      <H2 id="indemnification">9. Indemnification</H2>
      <P>
        You agree to indemnify and hold harmless Rolling Stone Marketing and its
        officers, employees, and agents from any claims, liabilities, damages,
        and expenses arising out of your use of the Site or your violation of
        these Terms.
      </P>

      <H2 id="governing-law">10. Governing Law</H2>
      <P>
        These Terms are governed by and construed in accordance with the laws of
        the State of {BUSINESS.state}, without regard to its conflict of laws
        principles.
      </P>

      <H2 id="changes">11. Changes to These Terms</H2>
      <P>
        We may update these Terms from time to time. Changes are effective when
        posted to this page, and the "Last updated" date above reflects the most
        recent revision.
      </P>

      <H2 id="contact">12. Contact</H2>
      <P>
        Rolling Stone Marketing
        <br />
        {BUSINESS.physicalAddress}
        <br />
        Mailing: {BUSINESS.mailingAddress}
        <br />
        Email: {BUSINESS.email}
        <br />
        Phone: {BUSINESS.phone}
        <br />
        Hours: {BUSINESS.hours}
      </P>
    </LegalLayout>
  );
}
